import React from 'react';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import Image from 'next/image';
import { FeatureRenererProps } from './types/FeatureRendererProps';

export default function FeatureRenderer({ feature }: FeatureRenererProps) {
  if (!feature) {
    return null;
  }

  if (feature.plainText?.[0] === 'yes') {
    return (
      <div className=" flex items-center justify-center pt-1">
        <Image
          src="/images/true.svg"
          className="-my-1 h-auto w-8 sm:-my-3 sm:w-12"
          width={47}
          height={47}
          alt="Checkmark"
        />
      </div>
    );
  }
  if (feature.plainText?.[0] === 'no') {
    return (
      <div className=" flex items-center justify-center pt-1">
        <Image
          src="/images/false.svg"
          className="-my-1 h-auto w-8 sm:-my-3 sm:w-12"
          width={47}
          height={47}
          alt="Cross"
        />
      </div>
    );
  }

  return <RichTextRenderer className="my-auto text-center text-sm sm:text-base" blocks={feature} />;
}
